import eventizer from  '../Assets/Images/projects/eventizer.png'
import dogBreed from  '../Assets/Images/projects/dog-breed.png'
import gitGud from  '../Assets/Images/projects/git-gud.png'
import indecision from  '../Assets/Images/projects/indecision.jpg'
import desuno from  '../Assets/Images/projects/desuno.jpg'
import fictional from  '../Assets/Images/projects/fictional.png'
import neighborhood from  '../Assets/Images/projects/neighborhood.png'
import gitsearch from  '../Assets/Images/projects/git_search.png'
import restaurant from  '../Assets/Images/projects/restaurant.png'
import arcade from  '../Assets/Images/projects/arcad-game.png'
import matching from  '../Assets/Images/projects/memory.png'
import myReads from  '../Assets/Images/projects/bookshelf.png'
import pixelArt from  '../Assets/Images/projects/pixel-art.png'
import imageSearch from  '../Assets/Images/projects/image-searcher.png'

export let projects =
 [
    { "id":1,
       "title": "eventizer",
       "description": "Ticket selling app written in NodeJs, Express, Sequelize, React and Redux. Full-stack app that lists Events, tickets for events, and Comments for tickets.",
       "href":"https://eventizer-client.herokuapp.com/",
       "src":eventizer,
       "alt":"Eventizer project"
    },
    {
      "id": 2,
      "title": "dog breed game",
      "description": "Group project made during the Coding Academy. Learning teamwork,  Gitflow, Agile, Scrum, React and Redux",
      "href": "https://pick-a-dog.netlify.app/",
      "src": dogBreed,
      "alt": "dog breed project screenschot"
    },
    {
      "id": 3,
      "title": "git-gud",
      "description": "A validator of GitHub profile and Git use, designed to provide feedback for job seekers.Team project for Codaisseur Academy. ",
      "href": "https://gitgud.netlify.app/",
      "src": gitGud,
      "alt": "git-gud project screenshot"
    },
    {
      "id": 4,
      "title": "indecision app",
      "description": "React Single Page Application using  Babel and Webpack. Users can input some tasks, and the app will suggest what to do.",
      "href": "https://nezmah.com/indecision/",
      "src": indecision,
      "alt": "indecision app project screenshot"
    },
    {
      "id": 5,
      "title": "desuno web page",
      "description": "Multilingual webpage made for the client. HTML, SASS, JS project with smooth scrolling, responsive navbar, picture carousel, and Google map. ",
      "href": "http://desuno.org/",
      "src": desuno,
      "alt": "desuno webpage project screenshot"
    },
    {
      "id": 6,
      "title": "fictional university",
      "description": "WordPress project including the whole web for University: Homepage, Blog, Campuses,  Programs and Professors as well as login page and comprehensive search.",
      "href": "https://nezmah.com/fictional-university/",
      "src": fictional,
      "alt": "fictional university project screenshot"
    },
    {
      "id": 7,
      "title": "my neighborhood",
      "description": "An application that uses Google Maps API and shows points of interest with additional data with filter options and Infowindows. Made with React.",
      "href": "https://nezmah.com/my-neighborhood/",
      "src": neighborhood,
      "alt": "0my neighborhood project screenshot"
    },
    {
      "id": 8,
      "title": "github search",
      "description": "React Single Page Application based on GitHub API. Find any profile and it’s statistics on GitHub. ",
      "href": "https://nezmah.com/git-api-app/",
      "src": gitsearch,
      "alt": "github search project screenshot"
    },
    {
      "id": 9,
      "title": "restaurant app",
      "description": "Google Maps based App showing restaurants in the area and their information. Including search and filter options based on cuisine type.",
      "href": "https://nezmah.com/restaurant-review/",
      "src": restaurant,
      "alt": "restaurant app project screenshot"
    },
    {
      "id": 10,
      "title": "arcade game",
      "description": " Recreation of old plain arcade game using HTML, CSS, and JS.",
      "href": "https://nezmah.com/arcade-game/",
      "src": arcade,
      "alt": "argade game project screenshot"
    },
    {
      "id": 11,
      "title": "matching game",
      "description": "Memory game with a timer, moves counter and rating system.  Sleek design with Font Awesome and animations.",
      "href": "https://nezmah.com/memory-game/",
      "src": matching,
      "alt": "matching game project screenshot"
    },
    {
      "id": 12,
      "title": "my reads app",
      "description": "Google books API Application build with React. You can track books you are reading and add new to the wishlist.",
      "href": "https://my-bookshelf.netlify.app/",
      "src": myReads,
      "alt": "my reads app project screenshot"
    },
    {
      "id": 13,
      "title": "pixel art maker",
      "description": "Popular Pixel art maker with options to choose canvas size, a whole spectrum of colors and right-click rubber.",
      "href": "https://nezmah.com/pixel-art/",
      "src": pixelArt,
      "alt": "pixel art maker project screenshot"
    },
    {
      "id": 14,
      "title": "image search",
      "description": "Image searching application using Pixabay API and Axios.Made with  React & Redux.",
      "href": "https://search-images-ed.netlify.app/",
      "src": imageSearch,
      "alt": "image search project screenshot"
    }
  ]